// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { loadPagesForParent } from "@insite/client-framework/Store/Data/Pages/PagesActionCreators";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import convertToNumberIfString from "@insite/mobius/utilities/convertToNumberIfString";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import { linkStyles } from "@store/Themes/common/mixins/link";
import constants from "@store/constants";
import { viewNotesClickHandler } from "@store/Framework/Services/FeaturesNotificationService";
import { linkTranslatableIcon } from "@store/Themes/common/mixins/link";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import parse from "html-react-parser";
import sortBy from "lodash/sortBy";
import truncate from "lodash/truncate";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    defaultPageSize = "defaultPageSize",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.defaultPageSize]: number;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const parsedQueryString = parseQueryString<{ page?: string; pageSize?: string; query?: string }>(location.search);
    const currentPage = getCurrentPage(state);
    const parameterId = currentPage.nodeId;
    const pages = getDataView(state.data.pages, { parentNodeId: getCurrentPage(state).nodeId });
    let links: SafeDictionary<PageLinkModel> = {};
    if (pages.value) {
        links = pages.value.reduce(
            (links, page) => ({ ...links, [page.nodeId]: getPageLinkByNodeId(state, page.nodeId) }),
            {},
        );
    }
    return {
        releaseNotes: pages,
        links,
        location,
        parameter: {
            page: parsedQueryString.page ? convertToNumberIfString(parsedQueryString.page) : undefined,
            pageSize: parsedQueryString.pageSize ? convertToNumberIfString(parsedQueryString.pageSize) : undefined,
            parentNodeId: parameterId,
            query: parsedQueryString.query,
        },
    };
};

const mapDispatchToProps = {
    loadPagesForParent,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface FeatureNotesListViewStyles {
    titleText?: TypographyProps;
    publishDateText?: TypographyProps;
    listWrapper?: InjectableCss;
    notesWrapper?: FlexWrapperPresentationProps;
    summaryWrapper?: InjectableCss;
    dateSummaryWrapper?: InjectableCss;
    dateAndAuthorWrapper?: InjectableCss;
    releaseTypeText?: InjectableCss;
    readMoreLink?: LinkPresentationProps;
    pagination?: PaginationPresentationProps;
    versionNumberBlock?: InjectableCss;
    readText?: TypographyProps;
    readMoreIcon?: IconPresentationProps;
    releaseNotesLink?: LinkPresentationProps;
    readNotesTextArrow?: InjectableCss;
}

export const featureNotesListViewStyles: FeatureNotesListViewStyles = {
    titleText: {
        size: 20,
        css: css`
            margin-bottom: 0;
            margin-top: 0;
        `,
    },
    notesWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    border-bottom: 1px solid ${getColor("common.border")};
                    ${spacingStyles(pxToRem(32), pxToRem(32))}
                    padding-bottom: ${pxToRem(32)};

                    &:last-child {
                        border-bottom: none;
                    }
                `,
            },
            content: {
                css: css`
                    flex-direction: row;
                    align-items: center;
                    ${breakpointValues([pxToRem(24), null, pxToRem(48)], "gap")}
                `,
            },
            item: {
                css: css`
                    ${breakpointValues(["unset", null, "1"], "flex")}

                    &:first-child {
                        ${breakpointValues(["100%", null, pxToRem(300)], "width")}
                        ${breakpointValues(["1", null, "0"], "flex-grow")}
                    }
                `,
            },
        },
    },
    pagination: {
        cssOverrides: {
            pagination: css`
                justify-content: center;
                padding-top: ${pxToRem(16)};
            `,
        },
    },
    dateSummaryWrapper: {
        css: css`
            flex: 1;
        `,
    },
    summaryWrapper: {
        css: css`
            margin: ${pxToRem(16, 0)};
        `,
    },
    versionNumberBlock: {
        css: css`
            ${breakpointValues(["100%", null, pxToRem(300)], "width")}
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-radius: ${pxToRem(16)};
            padding: ${pxToRem(32)};
            height: 100%;
        `,
    },
    readMoreIcon: {
        size: 20,
        src: ArrowForward,
        css: css`
            margin-left: ${pxToRem(16)};
            color: ${getColor("neutral.contrast")};
        `,
    },
    releaseNotesLink: {
        css: css`
            width: 100%;
            ${linkStyles("neutral.contrast", "neutral.contrast", false, false)}
            ${linkTranslatableIcon()}
        `,
        typographyProps: {
            css: css`
                display: inline-block;
                width: 100%;
            `,
        },
    },
    readNotesTextArrow: {
        css: css`
            display: flex;
            align-items: center;
            margin-top: ${pxToRem(16)};
        `,
    },
};

const styles = featureNotesListViewStyles;

const FeatureNotesListView = ({
    links,
    releaseNotes,
    fields: { defaultPageSize },
    parameter,
    history,
    location: { pathname },
    loadPagesForParent,
}: Props) => {
    const { value: pages, isLoading } = releaseNotes;

    const updateQueryString = (page: number, pageSize?: number) => {
        let newLocation = `${pathname}?page=${page}`;
        if (pageSize) {
            newLocation += `&pageSize=${pageSize}`;
        }
        history.push(newLocation);
    };

    const changePage = (newPageIndex: number) => {
        updateQueryString(newPageIndex, parameter.pageSize);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateQueryString(1, newPageSize);
    };

    useEffect(() => {
        if (!pages && !isLoading) {
            loadPagesForParent(parameter);
        }
    }, [releaseNotes]);

    if (!pages) {
        return null;
    }

    const publishedPages = pages.filter(x =>
        x.fields["unpublishDate"] ? new Date(x.fields["unpublishDate"]) > new Date() : true,
    );

    const totalItems = publishedPages.length;
    const pageSize = parameter.pageSize ?? defaultPageSize;
    const page = parameter.page ?? 1;

    const sortedAndPagedPages = sortBy(publishedPages, o => o.fields["publishDate"])
        .reverse()
        .slice((page - 1) * pageSize, page * pageSize);

    const linkClickHandler = (pageLink?: PageLinkModel, id?: string) => {
        if (pageLink) {
            viewNotesClickHandler(history, pageLink, id);
        }
    };

    const versionNumberBlockStyles = (page: PageProps) => {
        switch (page.fields["releaseType"]) {
            case "Minor":
                return {
                    css: css`
                        ${styles.versionNumberBlock?.css}
                        background-color: ${getColor("primary.light")};
                        color: ${getColor("primary.contrast")};
                    `,
                };
            case "Major":
                return {
                    css: css`
                        ${styles.versionNumberBlock?.css}
                        background-color: ${getColor("secondary.alt")};
                        color: ${getColor("neutral.contrast")};
                    `,
                };
            case "Hotfix":
                return {
                    css: css`
                        ${styles.versionNumberBlock?.css}
                        background-color: ${getColor("tertiary.light")};
                        color: ${getColor("tertiary.contrast")};
                    `,
                };
            case "default":
                return {
                    css: css`
                        ${styles.versionNumberBlock?.css}
                        background-color: ${getColor("neutral")};
                        color: ${getColor("neutral.contrast")};
                    `,
                };
        }
    };

    return (
        <StyledWrapper {...styles.listWrapper}>
            {sortedAndPagedPages.map((page: PageProps) => (
                <FlexWrapper {...styles.notesWrapper} key={page.id}>
                    <Link
                        onClick={() => linkClickHandler(links[page.nodeId], page.id)}
                        data-test-selector={`featureNotesList_ReadMore_${page.fields["title"]}`}
                        {...styles.releaseNotesLink}
                    >
                        <StyledWrapper {...versionNumberBlockStyles(page)} data-test-selector="featurenotes_pagetitle">
                            {page.fields["releaseType"] && (
                                <Typography {...styles.releaseTypeText} data-test-selector="featurenotes_publishdate">
                                    {translate(`${page.fields["releaseType"]}`)}
                                </Typography>
                            )}
                            <Typography variant="h2" {...styles.titleText}>
                                {page.fields["title"]}
                            </Typography>

                            <StyledWrapper {...styles.readNotesTextArrow}>
                                {translate("Read notes")}
                                <Icon {...styles.readMoreIcon} title={page.fields["title"]} />
                            </StyledWrapper>
                        </StyledWrapper>
                    </Link>
                    <StyledWrapper {...styles.dateSummaryWrapper}>
                        <StyledWrapper {...styles.dateAndAuthorWrapper}>
                            {page.fields["publishDate"] && (
                                <Typography {...styles.publishDateText} data-test-selector="featurenotes_publishdate">
                                    <LocalizedDateTime
                                        dateTime={new Date(page.fields["publishDate"])}
                                        options={{ year: "numeric", month: "numeric", day: "numeric" }}
                                    />
                                </Typography>
                            )}
                        </StyledWrapper>
                        {(page.fields["notesSummary"] || page.fields["newsContent"]) && (
                            <StyledWrapper {...styles.summaryWrapper} data-test-selector="featurenotes_content">
                                {parse(
                                    page.fields["notesSummary"] ||
                                        truncate(page.fields["newsContent"], { length: 500 }),
                                    parserOptions,
                                )}
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </FlexWrapper>
            ))}
            {totalItems > defaultPageSize && (
                <Pagination
                    {...styles.pagination}
                    resultsCount={totalItems}
                    currentPage={page}
                    resultsPerPage={pageSize}
                    onChangePage={changePage}
                    onChangeResultsPerPage={changeResultsPerPage}
                    resultsPerPageOptions={[
                        defaultPageSize,
                        defaultPageSize * 2,
                        defaultPageSize * 3,
                        defaultPageSize * 4,
                    ]}
                    pageSizeCookie="FeatureNotesList-PageSize"
                />
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(FeatureNotesListView)),
    definition: {
        group: constants.widgetGroup.featureNotesList,
        allowedContexts: [constants.pageType.featureNotesList],
        fieldDefinitions: [
            {
                name: fields.defaultPageSize,
                editorTemplate: "IntegerField",
                defaultValue: 5,
                fieldType: "General",
                min: 1,
                max: 20,
            },
        ],
    },
};

export default widgetModule;
